// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__tRKhu","breaker":"Navigation_breaker__10nQx","slider":"Navigation_slider__I1hm4"};